__turbopack_context__.v({
  "active": "Navbar-module__dVeNwG__active",
  "activeHeader": "Navbar-module__dVeNwG__activeHeader",
  "activeHeaderborder": "Navbar-module__dVeNwG__activeHeaderborder",
  "animate": "Navbar-module__dVeNwG__animate",
  "announcebtn": "Navbar-module__dVeNwG__announcebtn",
  "announcecont": "Navbar-module__dVeNwG__announcecont",
  "announcecont1": "Navbar-module__dVeNwG__announcecont1",
  "announcecont2": "Navbar-module__dVeNwG__announcecont2",
  "blinkAnimation": "Navbar-module__dVeNwG__blinkAnimation",
  "bluebtn": "Navbar-module__dVeNwG__bluebtn",
  "border": "Navbar-module__dVeNwG__border",
  "borderRadius": "Navbar-module__dVeNwG__borderRadius",
  "bottom-bar": "Navbar-module__dVeNwG__bottom-bar",
  "callus": "Navbar-module__dVeNwG__callus",
  "centerContent": "Navbar-module__dVeNwG__centerContent",
  "collapse": "Navbar-module__dVeNwG__collapse",
  "collapsed": "Navbar-module__dVeNwG__collapsed",
  "collapsing": "Navbar-module__dVeNwG__collapsing",
  "customDropdown": "Navbar-module__dVeNwG__customDropdown",
  "customDropdownMenu": "Navbar-module__dVeNwG__customDropdownMenu",
  "delhibtn": "Navbar-module__dVeNwG__delhibtn",
  "dropdown": "Navbar-module__dVeNwG__dropdown",
  "dropdown-item": "Navbar-module__dVeNwG__dropdown-item",
  "dropdown-menu": "Navbar-module__dVeNwG__dropdown-menu",
  "dropdown-toggle": "Navbar-module__dVeNwG__dropdown-toggle",
  "dropdownItem": "Navbar-module__dVeNwG__dropdownItem",
  "dropdownLink": "Navbar-module__dVeNwG__dropdownLink",
  "eventbutton": "Navbar-module__dVeNwG__eventbutton",
  "eventimg": "Navbar-module__dVeNwG__eventimg",
  "headerbutton": "Navbar-module__dVeNwG__headerbutton",
  "headerbuttonalink": "Navbar-module__dVeNwG__headerbuttonalink",
  "headercenterforlargedevice": "Navbar-module__dVeNwG__headercenterforlargedevice",
  "headerdropdown": "Navbar-module__dVeNwG__headerdropdown",
  "headerscroll": "Navbar-module__dVeNwG__headerscroll",
  "headertitles": "Navbar-module__dVeNwG__headertitles",
  "headertitles1": "Navbar-module__dVeNwG__headertitles1",
  "indexbtn": "Navbar-module__dVeNwG__indexbtn",
  "leftMenu": "Navbar-module__dVeNwG__leftMenu",
  "lock-scroll": "Navbar-module__dVeNwG__lock-scroll",
  "logo3d": "Navbar-module__dVeNwG__logo3d",
  "logoCenter": "Navbar-module__dVeNwG__logoCenter",
  "logobox": "Navbar-module__dVeNwG__logobox",
  "logoimg": "Navbar-module__dVeNwG__logoimg",
  "middle-bar": "Navbar-module__dVeNwG__middle-bar",
  "navWrapper": "Navbar-module__dVeNwG__navWrapper",
  "navbar-collapse": "Navbar-module__dVeNwG__navbar-collapse",
  "navbar-light": "Navbar-module__dVeNwG__navbar-light",
  "navbar-toggler": "Navbar-module__dVeNwG__navbar-toggler",
  "navbar-toggler-icon": "Navbar-module__dVeNwG__navbar-toggler-icon",
  "navbarbg": "Navbar-module__dVeNwG__navbarbg",
  "navbartopbg": "Navbar-module__dVeNwG__navbartopbg",
  "navcollapseclass": "Navbar-module__dVeNwG__navcollapseclass",
  "newnav1": "Navbar-module__dVeNwG__newnav1",
  "redbtn": "Navbar-module__dVeNwG__redbtn",
  "rightMenu": "Navbar-module__dVeNwG__rightMenu",
  "show": "Navbar-module__dVeNwG__show",
  "slideIn": "Navbar-module__dVeNwG__slideIn",
  "toggler-icon": "Navbar-module__dVeNwG__toggler-icon",
  "top-bar": "Navbar-module__dVeNwG__top-bar",
  "topdot": "Navbar-module__dVeNwG__topdot",
  "topheaderscroll": "Navbar-module__dVeNwG__topheaderscroll",
  "topleft": "Navbar-module__dVeNwG__topleft",
  "toptophead": "Navbar-module__dVeNwG__toptophead",
  "toptopheader": "Navbar-module__dVeNwG__toptopheader",
  "toptopheader1": "Navbar-module__dVeNwG__toptopheader1",
  "toptopheader2": "Navbar-module__dVeNwG__toptopheader2",
  "toptopheaderlinks": "Navbar-module__dVeNwG__toptopheaderlinks",
  "toptopheaderlinks1": "Navbar-module__dVeNwG__toptopheaderlinks1",
  "toptopheaderlinks2": "Navbar-module__dVeNwG__toptopheaderlinks2",
  "toptopheaderlinks3": "Navbar-module__dVeNwG__toptopheaderlinks3",
  "toptopheadlinks": "Navbar-module__dVeNwG__toptopheadlinks",
  "toptopleftsec": "Navbar-module__dVeNwG__toptopleftsec",
  "ulclass1": "Navbar-module__dVeNwG__ulclass1",
  "ulliclass1": "Navbar-module__dVeNwG__ulliclass1",
  "ullispan1": "Navbar-module__dVeNwG__ullispan1",
  "whatsnewkeyanimation": "Navbar-module__dVeNwG__whatsnewkeyanimation",
  "yellowbtn": "Navbar-module__dVeNwG__yellowbtn",
});
